var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.products_count > 0 || _vm.template === "search"
    ? _c("div", { staticClass: "collection__container wrapper" }, [
        _vm.template !== "search"
          ? _c(
              "aside",
              {
                staticClass: "collection-sidebar",
                class: { "with-image": _vm.image },
              },
              [
                _c("div", [
                  _c("div", { staticClass: "breadcrumbs-back" }, [
                    _c(
                      "a",
                      { attrs: { href: "/" } },
                      [
                        _c("IconChevron", {
                          attrs: { stroke: "#EEEEEE", direction: "left" },
                        }),
                        _vm._v("\n            Home\n          "),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.image
                    ? _c("img", { attrs: { src: _vm.image, alt: _vm.title } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "collection__sidebar-wrapper" }, [
                    _vm.description
                      ? _c("div", { staticClass: "collection__description" }, [
                          _c("p", {
                            domProps: { innerHTML: _vm._s(_vm.description) },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filtersApplied.length
                      ? _c(
                          "div",
                          {
                            staticClass: "collection__clear-filters",
                            on: {
                              click: function ($event) {
                                return _vm.clearFilters()
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("IconClose", {
                                  attrs: { stroke: "#62AF31" },
                                }),
                                _vm._v("Remove Filters"),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterOptions.length
                      ? _c(
                          "div",
                          { staticClass: "filter__group group--filter-by" },
                          [
                            _c(
                              "div",
                              {
                                class: [
                                  "filter__toggle",
                                  { open: _vm.filterByOpen },
                                ],
                                on: {
                                  click: function ($event) {
                                    _vm.filterByOpen = !_vm.filterByOpen
                                    _vm.sortByOpen = false
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "filter__title" }, [
                                  _vm._v("Filter By"),
                                ]),
                                _vm._v(" "),
                                _c("IconChevron", {
                                  attrs: {
                                    stroke: "#EEEEEE",
                                    direction: _vm.filterByOpen ? "up" : "down",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("TransitionExpand", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.filterByOpen,
                                      expression: "filterByOpen",
                                    },
                                  ],
                                  staticClass: "filter__dropdown",
                                },
                                _vm._l(
                                  _vm.filterOptions,
                                  function (filterGroup, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "filter__group--child",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "filter__toggle",
                                              {
                                                open: _vm.filtersOpen.includes(
                                                  index
                                                ),
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                _vm.toggleFilterBtn(index)
                                                _vm.sortByOpen = false
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "filter__title" },
                                              [
                                                _vm._v(
                                                  _vm._s(filterGroup.label)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("IconChevron", {
                                              attrs: {
                                                stroke: "#EEEEEE",
                                                direction:
                                                  _vm.filtersOpen.includes(
                                                    index
                                                  )
                                                    ? "up"
                                                    : "down",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "TransitionExpand",
                                          { attrs: { linear_margin: ".5rem" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.filtersOpen.includes(
                                                        index
                                                      ),
                                                    expression:
                                                      "filtersOpen.includes(index)",
                                                  },
                                                ],
                                                staticClass:
                                                  "filter__dropdown--child",
                                              },
                                              _vm._l(
                                                filterGroup.values,
                                                function (option, index) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key: index,
                                                      class: [
                                                        "filter__option",
                                                        _vm.showActive(
                                                          option.key
                                                        ),
                                                      ],
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.toggleFilter(
                                                            option.key,
                                                            _vm.stripKey(
                                                              option.key
                                                            ),
                                                            _vm.collectionID,
                                                            filterGroup.filterOptionId,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.stripKey(
                                                              option.key
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.noProductsfound
                      ? _c(
                          "div",
                          { staticClass: "filter__group group--sort-by" },
                          [
                            _c(
                              "div",
                              {
                                class: [
                                  "filter__toggle",
                                  { open: _vm.sortByOpen },
                                ],
                                on: {
                                  click: function ($event) {
                                    _vm.sortByOpen = !_vm.sortByOpen
                                    _vm.filterByOpen = false
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "filter__title" }, [
                                  _vm._v("Sort By"),
                                ]),
                                _vm._v(" "),
                                _c("IconChevron", {
                                  attrs: {
                                    stroke: "#EEEEEE",
                                    direction: _vm.sortByOpen ? "up" : "down",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("TransitionExpand", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sortByOpen,
                                      expression: "sortByOpen",
                                    },
                                  ],
                                  staticClass: "filter__dropdown",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        "filter__option",
                                        _vm.showActive("new"),
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleFilter(
                                            "sort by: new",
                                            "new",
                                            _vm.collectionID
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  New\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        "filter__option",
                                        _vm.showActive("lowest price"),
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleFilter(
                                            "sort by: lowest price",
                                            "lowest price",
                                            _vm.collectionID
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Lowest Price\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        "filter__option",
                                        _vm.showActive("highest price"),
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleFilter(
                                            "sort by: highest price",
                                            "highest price",
                                            _vm.collectionID
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Highest Price\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        "filter__option",
                                        _vm.showActive("best sellers"),
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleFilter(
                                            "sort by: best sellers",
                                            "best sellers",
                                            _vm.collectionID
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Best Sellers\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collection-main",
            class: { "with-image": _vm.image },
          },
          [
            _c(
              "header",
              { staticClass: "collection-title", attrs: { role: "banner" } },
              [
                _c(
                  "nav",
                  {
                    attrs: { role: "navigation", "aria-label": "breadcrumbs" },
                  },
                  [
                    _c("a", { attrs: { href: "/" } }, [
                      _vm._v(_vm._s(_vm.$language.breadcrumbs.home)),
                    ]),
                    _vm._v(" "),
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v(">"),
                    ]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "/collections/" + _vm.handle } }, [
                      _c("span", [_vm._v(_vm._s(_vm.title))]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.template == "search"
                  ? _c("h1", { staticClass: "h2" }, [
                      _vm._v("Search results for "),
                      _c("strong", [_vm._v(_vm._s(_vm.query))]),
                    ])
                  : _c("h1", { staticClass: "h2" }, [
                      _vm._v("Shop our range of "),
                      _c("strong", [_vm._v(_vm._s(_vm.title))]),
                    ]),
              ]
            ),
            _vm._v(" "),
            !_vm.noProductsfound
              ? _c(
                  "section",
                  { staticClass: "product-grid" },
                  _vm._l(_vm.products, function (product) {
                    return _c("ProductItem", {
                      key: product.id,
                      attrs: { product: product, collection: _vm.handle },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.noProductsfound
              ? _c(
                  "infinite-loading",
                  {
                    staticClass: "collection__products-infinite-loading",
                    attrs: { identifier: _vm.infiniteId },
                    on: { infinite: _vm.infiniteHandler },
                  },
                  [
                    _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
                    _vm._v(" "),
                    _c("div", {
                      attrs: { slot: "no-results" },
                      slot: "no-results",
                    }),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "spinner" }, slot: "spinner" }, [
                      _c("div", { staticClass: "site-loading" }, [
                        _c("div", { staticClass: "half-circle-spinner" }, [
                          _c("div", { staticClass: "circle circle-1" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "circle circle-2" }),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _c("div", { staticClass: "no-results" }, [
        _c(
          "header",
          {
            staticClass: "collection-title",
            staticStyle: { "text-align": "center" },
            attrs: { role: "banner" },
          },
          [
            _c(
              "nav",
              { attrs: { role: "navigation", "aria-label": "breadcrumbs" } },
              [
                _c("a", { attrs: { href: "/" } }, [
                  _vm._v(_vm._s(_vm.$language.breadcrumbs.home)),
                ]),
                _vm._v(" "),
                _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(">")]),
                _vm._v(" "),
                _c("a", { attrs: { href: "/collections/" + _vm.handle } }, [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("h1", { staticClass: "h2" }, [
              _vm._v("Shop our range of "),
              _c("strong", [_vm._v(_vm._s(_vm.title))]),
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Sorry, no products found")]),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }